import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Mail, Package, Wine } from 'lucide-react';
export function FreightGuidePage() {
  return <div className="min-h-screen bg-white" data-id="element-966">
      {/* Header */}
      <Header variant="dark" data-id="element-967" />

      {/* Hero Section */}
      <section className="bg-neutral-100 py-32 px-8 mt-32" data-id="element-968">
        <div className="max-w-4xl mx-auto text-center" data-id="element-969">
          <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-970" />
          <div className="text-brand-pink text-xs tracking-[0.4em] font-light uppercase mb-4" data-id="element-971">
            Shipping Information
          </div>
          <h1 className="font-heading text-5xl lg:text-6xl text-neutral-900 mb-6 leading-tight" data-id="element-972">
            Freight Guide
          </h1>
          <p className="text-lg text-neutral-600 leading-relaxed" data-id="element-973">
            Your guide to shipping costs across Australia
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="bg-white py-20 px-8" data-id="element-974">
        <div className="max-w-5xl mx-auto" data-id="element-975">
          {/* Introduction */}
          <div className="mb-12 text-center" data-id="element-976">
            <div className="w-12 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-977" />
            <h2 className="font-heading text-3xl text-neutral-900 mb-6" data-id="element-978">
              Peterson House Freight Guide
            </h2>
            <p className="text-neutral-600 text-lg leading-relaxed max-w-3xl mx-auto" data-id="element-979">
              Shipping costs can vary from state to state, suburb to suburb,
              courier to courier. Below is a guide to help our customers
              determine the shipping costs for their purchase.
            </p>
          </div>

          {/* Wine Club Member Rate */}
          <div className="mb-12 bg-brand-pink text-white p-8 text-center" data-id="element-980">
            <div className="flex items-center justify-center gap-3 mb-4" data-id="element-981">
              <Wine className="w-8 h-8" data-id="element-982" />
              <h3 className="font-heading text-2xl" data-id="element-983">Wine Club Members</h3>
            </div>
            <div className="text-5xl font-heading mb-2" data-id="element-984">$10</div>
            <p className="text-white/90 text-lg" data-id="element-985">
              Flat rate shipping Australia-wide for all Wine Club members
            </p>
            <p className="text-white/70 text-sm mt-4" data-id="element-986">
              Not a member?{' '}
              <a href="/wine-club" className="underline hover:text-white transition-colors" data-id="element-987">
                Join the Wine Club
              </a>{' '}
              to enjoy this exclusive benefit.
            </p>
          </div>

          {/* Pricing Table */}
          <div className="mb-4" data-id="element-988">
            <h3 className="font-heading text-xl text-neutral-900 mb-4 text-center" data-id="element-989">
              Standard Shipping Rates
            </h3>
          </div>
          <div className="mb-12 overflow-x-auto" data-id="element-990">
            <table className="w-full border-collapse bg-white" data-id="element-991">
              <thead data-id="element-992">
                <tr className="bg-neutral-900" data-id="element-993">
                  <th className="border border-neutral-300 px-6 py-4 text-left font-heading text-lg text-white" data-id="element-994">
                    STATE
                  </th>
                  <th className="border border-neutral-300 px-6 py-4 text-left font-heading text-lg text-white" data-id="element-995">
                    COST/WEIGHT
                  </th>
                  <th className="border border-neutral-300 px-6 py-4 text-left font-heading text-lg text-white" data-id="element-996">
                    COST/WEIGHT
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-997">
                <tr className="hover:bg-neutral-50 transition-colors" data-id="element-998">
                  <td className="border border-neutral-300 px-6 py-4 font-medium text-neutral-900" data-id="element-999">
                    NSW
                  </td>
                  <td className="border border-neutral-300 px-6 py-4 text-neutral-600" data-id="element-1000">
                    $12.50/up to 12 bottles
                  </td>
                  <td className="border border-neutral-300 px-6 py-4 text-neutral-600" data-id="element-1001">
                    $25.00/12 bottles or more
                  </td>
                </tr>
                <tr className="hover:bg-neutral-50 transition-colors" data-id="element-1002">
                  <td className="border border-neutral-300 px-6 py-4 font-medium text-neutral-900" data-id="element-1003">
                    QLD/VIC
                  </td>
                  <td className="border border-neutral-300 px-6 py-4 text-neutral-600" data-id="element-1004">
                    $15.00/up to 12 bottles
                  </td>
                  <td className="border border-neutral-300 px-6 py-4 text-neutral-600" data-id="element-1005">
                    $30.00/12 bottles or more
                  </td>
                </tr>
                <tr className="hover:bg-neutral-50 transition-colors" data-id="element-1006">
                  <td className="border border-neutral-300 px-6 py-4 font-medium text-neutral-900" data-id="element-1007">
                    NT/SA/WA/TAS
                  </td>
                  <td className="border border-neutral-300 px-6 py-4 text-neutral-600" data-id="element-1008">
                    $20.00/up to 12 bottles
                  </td>
                  <td className="border border-neutral-300 px-6 py-4 text-neutral-600" data-id="element-1009">
                    $40.00/12 bottles or more
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* International Freight Section */}
          <div className="bg-brand-pink/10 border-l-4 border-brand-pink p-8 rounded-none" data-id="element-1010">
            <div className="flex items-start gap-4" data-id="element-1011">
              <Package className="w-6 h-6 text-brand-pink mt-1 flex-shrink-0" data-id="element-1012" />
              <div data-id="element-1013">
                <h3 className="font-heading text-xl text-neutral-900 mb-3" data-id="element-1014">
                  International Freight
                </h3>
                <p className="text-neutral-600 leading-relaxed mb-4" data-id="element-1015">
                  If you would like to discuss international freight rates
                  please email us to obtain a quote.
                </p>
                <div className="flex items-center gap-3" data-id="element-1016">
                  <Mail className="w-5 h-5 text-brand-pink flex-shrink-0" data-id="element-1017" />
                  <a href="mailto:stockcontrol@petersonhouse.com.au" className="text-brand-pink hover:text-brand-pink/80 transition-colors font-medium" data-id="element-1018">
                    stockcontrol@petersonhouse.com.au
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Additional Information */}
          <div className="mt-12 text-center" data-id="element-1019">
            <p className="text-sm text-neutral-500 leading-relaxed" data-id="element-1020">
              Please note: Shipping costs are subject to change based on courier
              rates and delivery location. For the most accurate quote, please
              contact us directly.
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer data-id="element-1021" />
    </div>;
}